import { api } from "./api.service";

export async function changePassword(params: {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}) {
  const { data } = await api.post("/auth/change-password", {
    currentPassword: params.currentPassword,
    newPassword: params.newPassword,
    confirmPassword: params.confirmPassword,
  });

  return data;
}
